import { CompletedProgrammeWorkout, ProgrammeWorkout } from 'src/dao/core-dao'
import { useCompletedProgrammeWorkouts, useProgrammeWorkouts } from 'src/hook/use-programme-workouts'

export type UseProgrammeWorkoutProgressDataResult = {
  programmeWorkouts: ProgrammeWorkout[]
  completedProgrammeWorkouts: CompletedProgrammeWorkout[]
  /** Both programme and completion lists have completed at least one fetch. */
  isQueriesFetched: boolean
}

/**
 * Shared programme + completed workout queries for progress / next-workout hooks.
 */
export const useProgrammeWorkoutProgressData = (programmeId: string): UseProgrammeWorkoutProgressDataResult => {
  const { data: programmeWorkouts = [], isFetched: programmeWorkoutsFetched } = useProgrammeWorkouts(programmeId)
  const { data: completedProgrammeWorkouts = [], isFetched: completedProgrammeWorkoutsFetched } =
    useCompletedProgrammeWorkouts(programmeId)

  return {
    programmeWorkouts,
    completedProgrammeWorkouts,
    isQueriesFetched: programmeWorkoutsFetched && completedProgrammeWorkoutsFetched,
  }
}
